import React, { useState, useRef, useLayoutEffect } from 'react';
import Sketch from '@uiw/react-color-sketch';
import { useOutsideClick } from '@chakra-ui/hooks';
import { IoClose } from 'react-icons/io5';

import * as S from './styles';
import { hexToRgb } from 'utils/functions';

interface InputColorProps {
	value: any;
	setValue: any;
	rgbOrExadecimal?: boolean; //se true RGB se false Exadecimal
	label?: string;
	position?: 'fixed' | 'absolute' | 'sticky';
	top?: string | number;
	left?: string | number;
	right?: string | number;
	bottom?: string | number;
}

export default function InputColor({
	value,
	setValue,
	rgbOrExadecimal = true,
	label = '',
	position = 'fixed',
	top = 0,
	left = 0,
	right = 'auto',
	bottom = 'auto'
}: InputColorProps) {
	const modalRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);

	useLayoutEffect(() => {
		if (value) {
			if (rgbOrExadecimal) {
				const rgbValue = hexToRgb(value);
				if (JSON.stringify(value) !== JSON.stringify(rgbValue)) {
					setValue(rgbValue);
				}
			} else {
				if (typeof value === 'object') {
					setValue(value);
				}
			}
		}
	}, [value, rgbOrExadecimal]);

	useLayoutEffect(() => {
		if (isOpen) {
			const documentNoType: any = document;
			// Remove o foco do elemento ativo
			setTimeout(() => {
				if (documentNoType.activeElement) {
					documentNoType.activeElement.blur();
				}
			}, 0);
		}
	}, [isOpen]);

	// responsável por fechar modal ao clicar fora do componente
	useOutsideClick({
		ref: modalRef,
		handler: () => setIsOpen(false)
	});

	return (
		<S.colorContainer>
			{label !== '' && <p>{label}</p>}
			{isOpen && (
				<S.colorDiv
					$position={position}
					$top={top}
					$left={left}
					$right={right}
					$bottom={bottom}
					ref={modalRef}
				>
					<Sketch
						color={value || '#FFFFFF'}
						disableAlpha
						onChange={(color) => {
							setValue(color.hex);
						}}
					/>
					<S.btns>
						<S.clearModalBtn
							type="button"
							onClick={() => {
								setValue('');
								setIsOpen(false);
							}}
						>
							Limpar
						</S.clearModalBtn>
						<S.confirmBtn type="button" onClick={() => setIsOpen(false)}>
							Confirmar
						</S.confirmBtn>
					</S.btns>
				</S.colorDiv>
			)}

			<S.inputBox onClick={() => setIsOpen(!isOpen)}>
				<S.colorSquare $hexadecimalColor={value} />

				<p>
					{typeof value === 'object' && value !== null
						? `RGB: ${value.R}, ${value.G}, ${value.B}`
						: value
							? `Hex: ${value}`
							: 'Selecionar cor'}
				</p>

				{Boolean(value) && (
					<S.clearBtn
						type="button"
						title="Limpar cor"
						onClick={(e) => {
							e.stopPropagation();
							setValue('');
						}}
					>
						<IoClose size={16} />
					</S.clearBtn>
				)}
			</S.inputBox>
		</S.colorContainer>
	);
}
